<template>
  <md-card>
    <md-card-content>
      <div class="md-layout md-alignment-center-top">
        <div class="md-layout-item md-size-15" v-if="supply.image">
          <md-avatar class="md-avatar-icon md-primary md-large">
            <img v-lazy="supply.image" style="height: 256px" />
          </md-avatar>
        </div>
        <div class="md-layout-item">
          <div class="md-list-item-text">
            <span>
              <strong> {{ supply.name }} </strong>
            </span>
            <!-- <span> <strong>Tipo:</strong> {{supply.supplyTypeName}} / {{supply.supplyTypeShort}} </span> -->
            <span> <strong>Codigo</strong> {{ supply.code }} </span>
            <span> <strong>Clave SCT</strong> {{ supply.sctCode }} </span>
            <div class="md-layout">
              <div class="md-layout-item md-size-33">
                <p>
                  U.M: <strong>{{ supply.unitMeasurementAbbr }}</strong>
                </p>
              </div>
              <div class="md-layout-item md-size-33">
                <p>
                  Tipo: <strong>{{ supply.supplyTypeShort }}</strong>
                </p>
              </div>
              <div class="md-layout-item md-size-33">
                <p>
                  P.V: <strong>{{ supply.unitWeight }}</strong>
                </p>
              </div>
            </div>
          </div>
          <div v-if="showIcons">
            <md-button
              v-if="canChangeSupply"
              class="md-primary md-just-icon md-round edit"
              @click.stop="$emit('clicked-edit', supply)"
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top"> Editar </md-tooltip>
            </md-button>
            <md-button
              v-if="canChangeSupply"
              class="md-primary md-just-icon md-round edit"
              @click.stop="$emit('clicked-edit-with-camp', supply)"
            >
              <md-icon>widgets</md-icon>
              <md-tooltip md-direction="top"> Editar existencias </md-tooltip>
            </md-button>
            <md-button
              v-if="canDeleteSupply"
              class="md-primary md-just-icon md-round edit"
              @click.stop="$emit('remove-supply', supply)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top"> Borrar </md-tooltip>
            </md-button>
          </div>
        </div>
        <md-button
          class="md-simple md-primary md-just-icon md-layout-item md-size-10"
          v-if="supply.copies.length"
          @click="$emit('show-copies', supply)"
        >
          <md-icon>
            {{ expandedCopies ? "expand_less" : "expand_more" }}
          </md-icon>
          <md-tooltip> Ver copias </md-tooltip>
        </md-button>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  name: "SupplyItem",

  props: {
    supply: {
      type: Object,
      required: true,
    },
    showIcons: Boolean,
    expandedCopies: Boolean,
  },
  computed: {
    ...mapPermissions("Services", "supply", ["change", "delete"]),
  },
};
</script>

<style lang="css" scoped>
.floating {
  width: 40px !important;
  height: 40px !important;
  position: absolute;
  top: 78px;
  left: 8px;
  z-index: 2;
}

.md-content {
  max-width: 800px;
  max-height: 600px;
  overflow: auto;
}
.md-button.md-fab,
.md-button.md-just-icon {
  z-index: 4;
}

.md-list-item-content > .md-icon:first-child {
  margin-right: 0%;
}
.md-menu-content:not(.md-select-menu)
  .md-menu-content-container
  .md-list
  .md-list-item:not(:last-child) {
  margin-bottom: 0px;
}
.md-list-item-content {
  min-height: 48px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  transition: padding 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: padding;
}

.md-tooltip {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/SupplyItem.vue